<template>

    
      <!--CheckboxGroup :options="statusOptions" v-model:checked="model"> </CheckboxGroup-->
    <ul v-if="statusOptions">
      <li v-for="(item, index) in statusOptions" :key="index">
        <label>
          <input
            type="checkbox"
            v-model="model"
            :value="item.name"
            :checked="statusOptions.includes(item) ? true : false"
          />
          <span v-if="props.detailed_view">{{ item.description }}</span>
          <span v-else>{{ item.name }}</span>
        </label>
      </li>
    </ul>


  <div v-else>
    <p>fetching status options....</p>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useStatusStore, type Status } from '@/stores/status-store.ts'

const statusStore = useStatusStore();
const statusOptions = ref<Status[] | undefined>();
//const statusTest = Status.DESIGN
//const statusOptions = Object.keys(Status)
//const statusOptions = [ 'design', 'invoice', 'quote', 'inspection'];
const props = defineProps<{
  detailed_view : boolean
}>();
const model = defineModel<Status[]>('projectStatus')

onMounted(async() => {
  console.log('Project-status component mounted...')
  const fetched = await statusStore.getAll();
  statusOptions.value = fetched.map(option =>{
    return option;
  })

  //fetchTags();
})
</script>


<style lang="css" scoped>
label {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding-left: 0;
  padding-right: 1rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding-left: 0;
  padding-right: 1rem;
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  height: 100%;
  /*max-height: 24rem;*/
  /* margin-bottom: 1rem;*/
}
/*
div{
    display: flex;
    flex-flow: column wrap;
    max-height: 16rem;
}

input{
    height: 1rem;
    width: 1rem;
}
*/
span{
    display: block;
    font-size: 0.825rem;
    padding-left: 0.25rem;
}

</style>